import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FngLoadingIndicatorComponent } from '@festo-ui/angular';
import { StorageService, StorageType } from 'app/services/storage/storage.service';
import { Subscription } from 'rxjs';
import { ApplicationStore } from 'app/state-management/application/application.store';
import { ProfileStore } from 'app/state-management/profile/profile.store';
import { CurrentTenantService } from 'app/standalone-core/features';

@Component({
  selector: 'sma-web-page-redirect',
  templateUrl: './page-redirect.component.html',
  styleUrls: ['./page-redirect.component.scss'],
  imports: [FngLoadingIndicatorComponent],
})
export class PageRedirectComponent implements OnInit, OnDestroy {
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly profileStore = inject(ProfileStore);
  private readonly storageService = inject(StorageService);
  private readonly appStore: ApplicationStore = inject(ApplicationStore);
  private readonly currentTenantService: CurrentTenantService = inject(CurrentTenantService);

  readonly subscriptions = new Subscription();


  ngOnInit(): void {
    this.subscriptions.add(
      this.profileStore.profile$.subscribe(identity => {
        // this is called first with null
        if (!identity) {
          return;
        }

        // second call after identity was send from backend
        const tenantId: string = this.route.snapshot.queryParamMap.get('tid');
        let path: string = decodeURIComponent(this.route.snapshot.queryParamMap.get('path'));

        if (!tenantId || !path) {
          this.router.navigate(['/page-not-found']);
          return;
        }

        // Case for redirect from MAIL template
        if (path.includes('incidents/details')) {
          path = path.replace('incidents/details', 'incidents/for-machine/details');
        }

        if (identity.tenantId === tenantId) {
          // user is already in the right tenant
          this.router.navigate(['/'].concat(path.split('/')));
        } else {
          // wrong tenant: switch to the one from the parameters and reload whole application
          this.storageService.deleteAll(StorageType.Session);
          this.appStore.clearCachedApiData();
          this.currentTenantService.switchTo(tenantId, path);
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
